import React from "react"
import PropTypes from "prop-types"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import Unit from "views/atoms/reports/Unit"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const TRANSLATION_PREFIX = "analyze:it_domain.cloud.kpis.emissions_per_cost"

const TextAnalysisCloudEmissionsPerCost = ({ emissionsPerCost, trendBadge }) => {
  const { t } = useTranslation()

  const value = emissionsPerCost?.value
  const co2Unit = emissionsPerCost?.co2_unit_key
  const costUnit = emissionsPerCost?.cost_unit_key
  const hasValue = Number.isFinite(value) && !!co2Unit && !!costUnit

  const content = {
    kpi: hasValue ? value : "N/A",
    kpi_unit: hasValue ? (
      <>
        <Unit unit={t(`units:units.emission.${co2Unit}`)} />
        {" / "}
        <Unit unit={t(`units:units.money.${costUnit}`)} />
      </>
    ) : null,
    kpi_text: t(`${TRANSLATION_PREFIX}.title`),
  }

  return (
    <HelpWidgetChartInteractiveMolecule text={t(`${TRANSLATION_PREFIX}.help`)}>
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto">
        <TextChart content={<TextChartMinor content={content} noSubtextHover />} />
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

TextAnalysisCloudEmissionsPerCost.propTypes = {
  emissionsPerCost: PropTypes.shape({
    value: PropTypes.number,
    co2_unit_key: PropTypes.string,
    cost_unit_key: PropTypes.string,
  }),
  trendBadge: PropTypes.object,
}

TextAnalysisCloudEmissionsPerCost.defaultProps = {
  emissionsPerCost: null,
  trendBadge: null,
}

export default TextAnalysisCloudEmissionsPerCost
